module.exports = __webpack_public_path__ + "img/programme1.8616ef3f.png";